import AccessHelper from './access_helper';
import BaseTable from './base_table'
import GraphDataConverter from './graph_data_converter';
import SignalStrengthHelper from "./signal_strength_helper";
import FormatHelper from './format_helper';
import ValidationHelper from './validation_helper';
import HologramHelper from './hologram_helper';
import ReportDataHelper from './report_data_helper';

const debounce = (func, wait, immediate) => {
    var timeout;

    return (...args) => {
        var context = this;

        var later = () => {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
    };
};

export {
  AccessHelper,
  BaseTable,
  GraphDataConverter,
  SignalStrengthHelper,
  FormatHelper,
  ValidationHelper,
  HologramHelper,
  ReportDataHelper,
  debounce
};
